import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { MODE_CREATE } from "../../../codes";
import { rxShowLoanEditor, rxUpdateLoans, selectAllLoans } from "../../../slices/loansSlice";
import { addLoanInstallment, removeLastLoanInstallment } from "../../../api/ApiLoans";
import useToast from "../../../util/useToast";
import useNetwork from "../../../util/useNetwork";

const useLoans = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation("loans");
  const { showToastSuccess } = useToast();
  const { handleNetworkError } = useNetwork();

  const allLoans = useSelector(selectAllLoans);

  const [pendingInstallmentLoanId, setPendingInstallmentLoanId] = useState(null);

  const showLoanEditor = () => dispatch(rxShowLoanEditor({ mode: MODE_CREATE, loan: {} }));

  const runInstallmentAction = (loan, action, successMessage) => {
    if (pendingInstallmentLoanId) {
      return;
    }

    setPendingInstallmentLoanId(loan.id);

    return action(loan.id)
      .then(loans => dispatch(rxUpdateLoans(loans)))
      .then(() => showToastSuccess(t(successMessage)))
      .catch(error => handleNetworkError(error))
      .finally(() => setPendingInstallmentLoanId(null));
  };

  const addInstallment = loan => runInstallmentAction(loan, addLoanInstallment, "Échéance ajoutée");

  const removeInstallment = loan => runInstallmentAction(loan, removeLastLoanInstallment, "Échéance supprimée");

  return {
    t,
    allLoans,
    showLoanEditor,
    addInstallment,
    removeInstallment,
    pendingInstallmentLoanId,
  };
};

export default useLoans;
